// 获取购物车id
export const getCartId = async (params) => {
  const res = await paypalExpress(params)
  if (isEmpty(res)) {
    return ''
  } else {
    return res
  }
}
